import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChargeState } from 'src/app/shared/models/charge-state.model';
import { RemoteWifiConfiguration } from 'src/app/shared/models/wifi-pre-condition.model';

@Injectable()
export class PreConditionService {
  private readonly httpClient = inject(HttpClient);

  private readonly BASE_URL = '/api/vehicle/pre-condition';

  public configureWifi(
    vin: string,
    configuration: { dealer: string; wifiId: number }
  ): Observable<RemoteWifiConfiguration> {
    return this.httpClient.post<RemoteWifiConfiguration>(`${this.BASE_URL}/wifi/${vin}`, configuration);
  }

  public getVehicleEnergyStatus(vin: string, rsuNeeded: boolean): Observable<ChargeState> {
    return this.httpClient.get<ChargeState>(`${this.BASE_URL}/battery/${vin}?rsu-needed=${rsuNeeded}`);
  }
}
